export default {
  name: "User",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M19.96 15.76A6.965 6.965 0 0 0 23 10c0-3.86-3.14-7-7-7s-7 3.14-7 7c0 2.39 1.2 4.5 3.04 5.76C8.69 16.91 4.39 19.77 4 26.95V27c0 1.1.9 2 2 2h20c1.16 0 2-.84 2-2.05-.39-7.18-4.69-10.04-8.04-11.19zM11 10c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5zM6 26.99C6.58 17.16 15.62 17 16 17c.39 0 9.46.16 10 10l-20-.01z",
  },
}
